import {FiltersGameListPcDefaultBox} from "./filters-game-list-pc.default.box";

export const FiltersGameListPcBox = FiltersGameListPcDefaultBox;